import {
  ICurrentUpsellData,
  IPostUpsellVariant,
  Item,
} from '../../../../page-builder/interface/postUpsellInterface';
import { IBorderValueProps } from '../../../puck/reusable-props/Border';
import { getBorderProps } from '../../../utils/helper';

interface PostUpSellVarientProps {
  selectedVarient: IPostUpsellVariant;
  currentRecommendation: Item;
  currentDeviceType?: string;
  maxWidth?: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  height?: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  rating?: string;
  Startrate?: string;
  imageBorder?: IBorderValueProps;
  currentUpsellData: ICurrentUpsellData;
}
export const PostUpSellVarient = ({
  currentDeviceType,
  maxWidth,
  height,
  imageBorder,
  currentUpsellData,
  selectedVarient,
}: PostUpSellVarientProps) => {
  const imageUrl =
    selectedVarient?.productImage ||
    currentUpsellData?.products[0]?.variants[0]?.productVariants?.productImage;
  return (
    <div className="flex flex-col items-center">
      <img
        style={{
          ...(imageBorder && currentDeviceType
            ? getBorderProps(imageBorder, currentDeviceType)
            : {}),
          ...(currentDeviceType &&
          maxWidth &&
          height &&
          maxWidth[currentDeviceType] !== undefined &&
          height[currentDeviceType] !== undefined
            ? {
                maxWidth: isNaN(+maxWidth[currentDeviceType])
                  ? maxWidth[currentDeviceType]
                  : `${+maxWidth[currentDeviceType]}px`,
                height: isNaN(+height[currentDeviceType])
                  ? height[currentDeviceType]
                  : `${+height[currentDeviceType]}px`,
              }
            : {}),
        }}
        className={`${currentDeviceType ? imageBorder?.borderStyle?.[currentDeviceType] : []} `}
        src={imageUrl}
        alt="Product-Image"
      />
    </div>
  );
};
